import Cookies from 'js-cookie'

let initialState = {
    data: {},
    isAuth: false,
    name: {
        first: null,
        second: null,
    },
    cart: JSON.parse(localStorage.getItem('cart') ?? '[]'),
}

let authReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_AUTH':
            if (action.data) {
                return {
                    ...state,
                    data: action.data,
                    name: {
                        first: action.data.user_metadata.first_name,
                        second: action.data.user_metadata.second_name,
                    },
                }
            }

            return {
                ...state,
                data: {},
            }

        case 'SET_IS_AUTH':
            return {
                ...state,
                isAuth: action.bool,
            }

        case 'SET_UPDATED_CART':
            let newCart = [...state.cart],
                item = newCart.find((i) => i.id == action.obj.id)

            if (action.actionType == 'delete') {
                if (item.count == 1) {
                    newCart.splice(
                        newCart.findIndex((i) => i.id == item.id),
                        1
                    )
                }

                item.count -= 1
            } else {
                item
                    ? (item.count += 1)
                    : newCart.push({
                          ...action.obj,
                          count: 1,
                      })
            }

            localStorage.setItem('cart', JSON.stringify(newCart))

            return {
                ...state,
                cart: newCart,
            }

        default:
            return state
    }
}

export const setAuthData = (data) => ({ type: 'SET_AUTH', data })
export const setIsAuth = (bool) => ({ type: 'SET_IS_AUTH', bool })
export const setUpdatedCart = (obj, actionType) => ({
    type: 'SET_UPDATED_CART',
    obj,
    actionType,
})

export default authReducer
